import { processConfig } from "../config/env";
import { checkWebviewerFileStatus } from "../http/api/webviewer";
import { getEncryptDataFromPath } from "../utils";
import { getUrlType, URL_TYPE } from "./url";

const _AWS_BUCKET = processConfig.env.S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V2;

export const checkIsStageInvalid = async () => {
  try {
    const { key, bucket } = await getBucketAndKey();
    const {
      data: { exportResultCode },
    } = await checkWebviewerFileStatus({
      key,
      bucket,
    });
    if (exportResultCode === 1) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

const getBucketAndKey = async () => {
  const urlType = getUrlType();

  if (urlType === URL_TYPE.OPEN_IN_WEB_VIEWER) {
    return getBucketAndKeyByOpenInWebViewer();
  }

  if (urlType === URL_TYPE.SHAREABLE_LINK) {
    return await getBucketAndKeyByShareableLink();
  }

  throw new Error("Invalid URL");
};

const getBucketAndKeyByOpenInWebViewer = () => {
  const { userId, path } = getEncryptDataFromPath();

  const jsonKey = path.replace(".zip", ".json");
  const key = `${userId}/${jsonKey}`;
  const bucket = _AWS_BUCKET;

  return {
    key,
    bucket,
  };
};

const getBucketAndKeyByShareableLink = async () => {
  const { downloadUrl } = getEncryptDataFromPath();
  const decodeUrl = atob(downloadUrl);

  const urlParts = new URL(decodeUrl);
  const hostnameParts = urlParts.hostname.split(".");

  let bucket = hostnameParts[0];

  const pathParts = urlParts.pathname.split("/");
  let key = pathParts.slice(1).join("/");
  const jsonKey = key.replace(".zip", ".json");

  return {
    bucket: bucket,
    key: jsonKey,
  };
};
